import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
export default function CouponDetailsAlert({
  open,
  setOpen,
  message,
  title,
  getItNow,
  promoType,
  getNowButtonCouponsType,
}) {
  const { t } = useTranslation();
  // const lines = message?.split("\n");
  return (
    <Dialog open={open} onOpenChange={(isOpen) => setOpen(isOpen)}>
      <DialogContent className="p-0 rounded-lg sm:rounded-[20px] overflow-y-auto max-h-[calc(100vh-4rem)]">
        <div className="px-16 pt-5 pb-4 bg-green">
          <p className="text-green-900 text-lg sm:text-xl font-bold text-center">
            {title}
          </p>
        </div>
        <DialogHeader className="px-4 py-3 sm:py-6 space-y-1.5 gap-y-2">
          {message?.map((line, index) => {
            if (!line) return null;
            return (
              <>
                <DialogTitle
                  className="text-start max-sm:text-base"
                  key={index}
                >
                  {line.title}
                </DialogTitle>

                <DialogDescription
                  className="text-start max-sm:text-base"
                  key={index}
                >
                  <ul className="list-disc list-inside">
                    {line.description?.map((description, index) => (
                      <li className="text-start max-sm:text-base" key={index}>
                        {t(description)}
                      </li>
                    ))}
                  </ul>
                </DialogDescription>
              </>
            );
          })}
        </DialogHeader>
        <DialogFooter>
          {/* footer */}
          <div className="w-full p-5 flex items-center justify-center border-t gap-x-2">
            {/* <DialogAction className="h-auto px-3 sm:px-6 py-2 sm:py-3 text-sm sm:text-base font-bold bg-red border border-red rounded-full text-white hover:opacity-85 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-red transition-ease">
              {t("close.button")}
            </DialogAction> */}
            <Button
              variant="secondary"
              className="w-full"
              onClick={() => setOpen(false)}
            >
              {t("coupon.back_to_menu")}
            </Button>
            {getNowButtonCouponsType.includes(promoType) && (
              <Button variant="coupon" className="w-full" onClick={getItNow}>
                {t("coupon.get_it_now")}
              </Button>
            )}
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
